import {Injectable} from "@angular/core";
import {UrlBuilder} from "../../url-builder/url.builder";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CalibrationData} from "../../calibration/calibrationStatus";
import {ValveData} from "./valvedosagemodel";


@Injectable({
  providedIn: 'root'
})
export class ValveRunDosageDataService {

  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<ValveData[]> {
    this.uiUrl = this.url.GetValveDosageDataUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<ValveData[]>(this.uiUrl);
  }

}

